const FileIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M13.7532 18.75C15.2507 18.75 16.4993 18.7499 17.4906 18.8832C18.537 19.0239 19.4816 19.3333 20.2407 20.0924C20.9999 20.8515 21.3093 21.7962 21.45 22.8425C21.5833 23.8338 21.5832 25.0825 21.5832 26.58V26.58V30.0867V30.0867C21.5832 31.5842 21.5833 32.8328 21.45 33.8241C21.3093 34.8705 20.9999 35.8151 20.2407 36.5742C19.4816 37.3334 18.537 37.6428 17.4906 37.7835C16.4993 37.9168 15.2507 37.9167 13.7532 37.9167H13.7532H10.2465H10.2465C8.74902 37.9167 7.50034 37.9168 6.50904 37.7835C5.46272 37.6428 4.51805 37.3334 3.75894 36.5742C2.99982 35.8151 2.69037 34.8705 2.54969 33.8241C2.41642 32.8328 2.41646 31.5842 2.41651 30.0867V30.0867L2.41651 26.58V26.58C2.41646 25.0825 2.41642 23.8338 2.54969 22.8425C2.69037 21.7962 2.99982 20.8515 3.75894 20.0924C4.51805 19.3333 5.46272 19.0239 6.50904 18.8832C7.50033 18.7499 8.74901 18.75 10.2465 18.75H10.2465H13.7532H13.7532Z"
        fill="#0051FF"
      />
      <path
        d="M30.3332 22.9151C31.2537 22.9151 31.9999 23.6613 31.9999 24.5817L31.9999 29.6737C31.9999 31.1666 32 32.4202 31.8927 33.4175C31.7814 34.4521 31.5347 35.4619 30.8536 36.3132C30.1653 37.1736 29.2792 37.5682 28.3321 37.7468C27.4742 37.9087 26.4381 37.9141 25.3346 37.915C24.4141 37.9157 23.6673 37.1702 23.6666 36.2497C23.6658 35.3292 24.4114 34.5824 25.3319 34.5816C26.5218 34.5807 27.2223 34.564 27.7142 34.4713C28.1167 34.3953 28.1933 34.3027 28.2507 34.2309C28.3507 34.106 28.4945 33.842 28.5785 33.0611C28.6643 32.2634 28.6666 31.191 28.6666 29.5817L28.6666 24.5817C28.6666 23.6613 29.4128 22.9151 30.3332 22.9151Z"
        fill="#0051FF"
      />
      <path
        d="M10.3332 23.3317C9.41276 23.3317 8.66657 24.0779 8.66657 24.9984C8.66657 25.9189 9.41276 26.6651 10.3332 26.6651L13.6666 26.6651C14.587 26.6651 15.3332 25.9189 15.3332 24.9984C15.3332 24.0779 14.587 23.3317 13.6666 23.3317L10.3332 23.3317Z"
        fill="#0051FF"
      />
      <path
        d="M22.4166 10.0656C22.4166 5.66809 25.9492 2.08173 30.3332 2.08173C34.7173 2.08173 38.2499 5.66809 38.2499 10.0656C38.2499 12.597 37.2259 14.5771 35.3289 16.2581C34.2695 17.197 32.9596 18.8534 32.0939 20.1781C31.7628 20.6847 31.1748 21.2484 30.3222 21.2484C29.4555 21.2484 28.8708 20.6685 28.5517 20.145C27.7566 18.8408 26.4117 17.2099 25.3375 16.2581C23.4406 14.5771 22.4166 12.597 22.4166 10.0656Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default FileIcon;
